import { QueryClient } from '@tanstack/react-query';

const isAuthError = (error) => {
  return error?.response?.status === 401 || error?.response?.status === 403;
};

const isNetworkError = (error) => {
  return error?.code === 'ERR_NETWORK' || error?.code === 'NETWORK_ERROR';
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry auth errors - these should be handled by interceptors
        if (isAuthError(error)) {
          return false;
        }
        
        // Retry network errors up to 2 times
        if (isNetworkError(error) && failureCount < 2) {
          return true;
        }
        
        // Default retry logic for other errors
        return failureCount < 1;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: (failureCount, error) => {
        // Never retry auth errors for mutations
        if (isAuthError(error)) {
          return false;
        }
        
        // Only retry network errors once for mutations
        if (isNetworkError(error) && failureCount < 1) {
          return true;
        }
        
        return false;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 10000),
    }
  }
});
